import { render, staticRenderFns } from "./done.vue?vue&type=template&id=6488c575&scoped=true"
import script from "./done.vue?vue&type=script&lang=js"
export * from "./done.vue?vue&type=script&lang=js"
import style0 from "./done.vue?vue&type=style&index=0&id=6488c575&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6488c575",
  null
  
)

export default component.exports